import { useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';

export function useQueryData(query: any, variable: any, condition: any, isNetWorkOnly?: any, onCompleted?: any) {
    const [dataQuery, setDataQuery] = useState<any>();
    let [queryData, loading] = useLazyQuery(query, {
        fetchPolicy: typeof isNetWorkOnly === 'string' ? isNetWorkOnly : isNetWorkOnly && 'network-only',
        variables: {
            input: variable,
        },
        context: {
            scope: 'private',
        },
        onCompleted(response) {
            onGetDataQuery(response);
            if (onCompleted) {
                onCompleted();
            }
        },
        onError(error) {
            console.error('get data Failed: ', error);
        },
    });
    const onGetDataQuery = (response) => {
        setDataQuery(response);
    };
    useEffect(() => {
        if (condition) queryData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [condition]);
    return { dataQuery, loading };
}
